import { KYMW1407Component } from './kymw1407.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW0B00InputModel } from '../../../commons/kymw0b/kymw0b00/vo/kymw0b00-input.model';
import { KYMW0C00InputModel } from '../../../commons/kymw0c/kymw0c00/vo/kymw0c00-input.model';
import { KYMW0E00InputModel } from '../../../commons/kymw0e/kymw0e00/vo/kymw0e00-input.model';
import { KYMW0B00OutputModel } from '../../../commons/kymw0b/kymw0b00/vo/kymw0b00-output.model';
import { KYMW1407ImageInfoDetailBoxComponent } from './kymw1407-image-info-detail-box/kymw1407-image-info-detail-box.component';
import { Menu } from '@grapecity/wijmo.input';
import { GetImageListModel } from '../kymw1400/vo/get-image-list.model';
import { GetSearchImageListModel } from '../kymw1400/vo/get-search-image-list.model';
import { GetImageInfoDetailModel } from '../kymw1400/vo/get-image-info-detail.model';
import { GetImageFileUrlModel } from '../kymw1400/vo/get-image-file-url.model';
import { UpdateUseImageModel } from '../kymw1400/vo/update-use-image.model';
import { RegistUseImageModel } from '../kymw1400/vo/regist-use-image.model';
import { GetUseRecordListModel } from '../kymw1400/vo/get-use-record-list.model';
import { GetUseRecordImageListModel } from '../kymw1400/vo/get-use-record-image-list.model';
import { UpdateImageInfoModel } from '../kymw1400/vo/update-image-info.model';
import { UpdateImageInfoEnabledModel } from '../kymw1400/vo/update-image-info-enabled.model';
import { Injectable } from "@angular/core";

/**
 * 画像指示画面の値を管理するクラス
 *
 * @export KYMW1407Model
 * @class KYMW1407Model
 */
@Injectable()
export class KYMW1407Model {

  kymw1407Component: KYMW1407Component;

  /* ヘッダー部 */
  public pcode = String('');
  public guideGoodsName = String('');
  public guideStandardName = String('');
  /* 使用画像部 */
  public useImageList: Array<any> = Array<any>();
  /* 検索結果部 */
  public goodsImageList: Array<any> = Array<any>();
  public pcodeList: Array<any> = null;
  public pcodeInfoList: Array<any> = null;
  public useHistoryImageList: Array<any> = Array<any>();
  public searchImageList: Array<any> = Array<any>();
  /* 画像情報詳細 */
  public goodsImagePreviewURL: string = null;

  public goodsImagePreviewPath: string = null;
  public goodsImageFilePath: string = null;
  public flag: boolean = <boolean>false;

  /*-----------------------------------------------------------------------------------------------
  情報変数
  -----------------------------------------------------------------------------------------------*/
  // InputVO
  public selectedOrderCode = String('');			// 受注コード
  public selectedCoopCode = String('');			// 生協コード
  public selectedKomaId = String('');				// 選択されたコマID
  public editMode = Boolean(false);				// 編集モード
  public selectedImageExistFlg = Boolean(false);	// 選択画像存在フラグ

  // 抽出結果
  public selectedImageData: any = null;		// 選択されたイメージID
  public tempSelectedImageData: any = null;	// 仮選択イメージID
  public imageInfoDetailChangeFlg: boolean = null;	// 画像詳細情報変更フラグ

  // 履歴情報
  public startOrderCodeBefore: string = null;
  public endOrderCodeBefore: string = null;

  public otherGoodsCount = String('');

  public readonly IMAGE_LIST_COUNT: number = Number(1000); // 画像検索結果最大表示数

  public imageType = String('');					// 画像種別


  // 画像詳細情報初期値
  public startOrderCodeOrigin: string = <string>'';
  public endOrderCode1Origin: string = <string>'';

  /*-----------------------------------------------------------------------------------------------
  バインド情報更新
  -----------------------------------------------------------------------------------------------*/
  /**
   * 画像情報更新
   *
   * @param {*} data
   * @memberof KYMW1407Model
   */
  public updateImageList(data: any): void {
    // 初期化処理
    this.clear();

    this.pcode = data.Pcode;
    this.guideGoodsName = data.GuideGoodsName;
    this.guideStandardName = data.GuideStandardName;
    if (data.UseImageList != null) {
      this.useImageList = data.UseImageList;
    }
    if (data.GoodsImageList != null) {
      this.goodsImageList = data.GoodsImageList;
      this.kymw1407Component.vw_SearchResult.goodsImageCnt = this.goodsImageList.length;
    }
    if (data.PcodeList != null) {
      this.pcodeList = data.PcodeList;
    }

    this.procViewEnable();

    if (!PlessViewUtilsSub.isEmpty(this.pcode)) {
      this.kymw1407Component.vw_SearchResult.tab_SearchResult.selectedIndex = Number(0);
    }

    // Angularの変更検知を強制的に実行
    this.kymw1407Component.chRef.detectChanges();
  }

  /**
   * 画像詳細情報更新
   *
   * @param {*} data
   * @memberof KYMW1407Model
   */
  public updateImageInfoDetail(data: any): void {
    this.imageInfoDetailBox.clear();

    let endOrderCode2 = Number(0);
    if (data.EndOrderCode === '9999999') {
      endOrderCode2 = 1;
      data.EndOrderCode = '';
    } else if (String(data.StartOrderCode) === String(data.EndOrderCode)) {
      endOrderCode2 = 2;
    }

    this.startOrderCodeOrigin = data.StartOrderCode;
    this.endOrderCode1Origin = data.EndOrderCode;
    this.imageInfoDetailBox.txi_StartOrderCode.setOrderCode(data.StartOrderCode);
    this.imageInfoDetailBox.startOrderCode = data.StartOrderCode;
    this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode(data.EndOrderCode);
    this.imageInfoDetailBox.endOrderCode1 = data.EndOrderCode;
    this.imageInfoDetailBox.endOrderCode2 = endOrderCode2.toString();
    this.imageInfoDetailBox.imageName = data.ImageName;
    this.imageInfoDetailBox.imageFileName = data.ImageFileName;
    this.imageInfoDetailBox.imageBelongName = this.getCodeValueName(data.ImageBelongId, data.ImageBelongName);
    this.imageInfoDetailBox.imageKindName = this.getCodeValueName(data.ImageKind, data.ImageKindName);
    this.imageInfoDetailBox.imageTypeName = this.getCodeValueName(data.ImageType, data.ImageTypeName);
    this.imageInfoDetailBox.cmb_ProcessInstruct.setCodeValue(data.ProcessInstruct);
    this.imageInfoDetailBox.remarks = data.Remarks;
    this.imageInfoDetailBox.cookingExPublish = PlessViewUtilsSub.StringTOBoolean(data.CookingExPublish);
    this.imageInfoDetailBox.priority = data.Priority;
    this.imageInfoDetailBox.pcode = data.Pcode;
    this.imageInfoDetailBox.guideGoodsName = data.GuideGoodsName;
    this.imageInfoDetailBox.guideStandardName = data.GuideStandardName;
    this.imageInfoDetailBox.cmb_CookingDiv.setCodeValue(data.CookingDiv);
    this.imageInfoDetailBox.cookingName = data.CookingName;
    this.imageInfoDetailBox.materialName = data.MaterialName;
    this.imageInfoDetailBox.keyWord = data.KeyWord;
    this.imageInfoDetailBox.cmb_EventId.setCodeValue(data.EventId);
    this.imageInfoDetailBox.cmb_PhotoContentsDiv.setCodeValue(data.PhotoContentsDiv);
    this.imageInfoDetailBox.photoInstructContents = data.PhotoInstructContents;
    this.imageInfoDetailBox.photoSchedule =
      PlessViewUtilsSub.editDate(PlessViewUtilsSub.nullToBlank(data.PhotoSchedule), '2');
    this.imageInfoDetailBox.cmb_PhotoStudioId.setStudioId(data.PhotoStudioId);
    this.imageInfoDetailBox.imageInstructDate = data.ImageInstructDate;
    this.imageInfoDetailBox.fileRegistDate = data.FileRegistDate;
    this.imageInfoDetailBox.caption = data.TextCaption;

    this.goodsImagePreviewURL = data.ImagePreviewUrl;

    this.goodsImagePreviewPath = data.ImagePreviewPath;
    this.goodsImageFilePath = data.ImageFilePath;
    this.startOrderCodeBefore = data.StartOrderCode;
    this.endOrderCodeBefore = data.EndOrderCode;

    // 画像種別を退避
    this.imageType = data.ImageType;

    this.procViewEnable();
  }

  /**
   * 使用履歴・Pコード情報リスト情報更新
   *
   * @param {*} data
   * @memberof KYMW1407Model
   */
  public updatePcodeInfoList(data: any): void {
    this.pcodeInfoList = new Array<any>();
    if (data != null) {
      this.pcodeInfoList = data;
    }
  }

  /**
   * 使用履歴・画像リスト情報更新
   *
   * @param {*} data
   * @memberof KYMW1407Model
   */
  public updateUseHistoryImageList(data: any): void {
    this.useHistoryImageList = new Array<any>();
    if (data != null) {
      this.useHistoryImageList = data;
      this.kymw1407Component.vw_SearchResult.useHitoryImageCnt = this.useHistoryImageList.length;
    }
  }

  /**
   * 使用履歴・検索画像画像リスト情報更新
   *
   * @param {*} data
   * @memberof KYMW1407Model
   */
  public updateSearchImageList(data: any): void {
    if (data != null && data.length != 0) {
      let imageCnt = Number(0);
      if (data.length > this.IMAGE_LIST_COUNT) {
        this.kymw1407Component.dialogService.openAlertGetMessage('I0102', ['1000', '1000']);

        const searchImage1000List: Array<any> = new Array<any>();

        // 表示最大値ほど加工して表示
        for (let cnt = Number(0); cnt < data.length; cnt++) {
          if (cnt === this.IMAGE_LIST_COUNT) {
            imageCnt = cnt;
            break;
          }
          searchImage1000List.push(data[cnt]);
        }

        this.searchImageList = searchImage1000List;
      } else {
        this.searchImageList = new Array<any>();
        this.searchImageList = data;
        imageCnt = data.length;
      }

      this.kymw1407Component.vw_SearchResult.searchImageCnt = imageCnt;

    } else {
      this.kymw1407Component.dialogService.openAlertGetMessage('E0100');
    }
  }

  /*-----------------------------------------------------------------------------------------------
  VO Getter
  -----------------------------------------------------------------------------------------------*/
  /**
   * GetImageListVOを取得する
   *
   * @returns {GetImageListModel}
   * @memberof KYMW1407Model
   */
  public getGetImageListVO(): GetImageListModel {
    const vo: GetImageListModel = new GetImageListModel();
    vo.komaID = this.selectedKomaId;
    return vo;
  }

  /**
   * GetImageInfoDetailVOを返却する
   *
   * @returns {GetImageInfoDetailModel}
   * @memberof KYMW1407Model
   */
  public getGetImageInfoDetailVO(): GetImageInfoDetailModel {
    const vo: GetImageInfoDetailModel = new GetImageInfoDetailModel();
    vo.imageId = this.selectedImageData.ImageId;
    return vo;
  }

  /**
   * GetImageFileUrlVOを返却する
   *
   * @returns {GetImageFileUrlModel}
   * @memberof KYMW1407Model
   */
  public getGetImageFileUrlVO(): GetImageFileUrlModel {
    const vo: GetImageFileUrlModel = new GetImageFileUrlModel();
    vo.imageFilePath = this.goodsImageFilePath;
    vo.imageFileName = this.imageInfoDetailBox.imageFileName + '.eps';
    vo.imagePreviewPath = this.goodsImagePreviewPath;
    vo.imagePreviewName = this.imageInfoDetailBox.imageFileName + '.png';
    return vo;
  }

  /**
   * UpdateUseImageVOを返却する
   *
   * @returns {UpdateUseImageModel}
   * @memberof KYMW1407Model
   */
  public getUpdateUseImageVO(): UpdateUseImageModel {
    const vo: UpdateUseImageModel = new UpdateUseImageModel();
    vo.komaId = this.selectedKomaId;
    vo.useImageList = this.useImageList;
    return vo;
  }

  /**
   * RegistUseImageVOを返却する
   *
   * @returns {RegistUseImageModel}
   * @memberof KYMW1407Model
   */
  public getRegistUseImageVO(): RegistUseImageModel {
    const vo: RegistUseImageModel = new RegistUseImageModel();
    vo.komaId = this.selectedKomaId;
    vo.imageId = this.selectedImageData.ImageId;
    vo.pcode = this.pcode;
    vo.showSeq = this.useImageList.length;
    return vo;
  }

  /**
   * GetUseRecordListVOを返却する
   *
   * @returns {GetUseRecordListModel}
   * @memberof KYMW1407Model
   */
  public getGetUseRecordListVO(): GetUseRecordListModel {
    const vo: GetUseRecordListModel = new GetUseRecordListModel();
    vo.coopCode = this.selectedCoopCode;
    vo.pcode = this.kymw1407Component.vw_SearchResult.pCode;
    vo.thisOrderCode = this.selectedOrderCode;
    return vo;
  }

  /**
   * GetUseRecordImageListVOを返却する
   *
   * @returns {GetUseRecordImageListModel}
   * @memberof KYMW1407Model
   */
  public getGetUseRecordImageListVO(): GetUseRecordImageListModel {
    const vo: GetUseRecordImageListModel = new GetUseRecordImageListModel();
    vo.orderCode = this.kymw1407Component.vw_SearchResult.dgv_PcodeInfoList.selectedItems[0].OrderCode;
    vo.mediumType = this.kymw1407Component.vw_SearchResult.dgv_PcodeInfoList.selectedItems[0].MediumType;
    vo.coopCode = this.selectedCoopCode;
    vo.pcode = this.kymw1407Component.vw_SearchResult.pCode;
    vo.thisOrderCode = this.selectedOrderCode;
    return vo;
  }

  /**
   * GetSearchImageListVOを返却する
   *
   * @param {KYMW0B00OutputModel} outputVO
   * @returns {GetSearchImageListModel}
   * @memberof KYMW1407Model
   */
  public getGetSearchImageListVO(outputVO: KYMW0B00OutputModel): GetSearchImageListModel {
    const vo: GetSearchImageListModel = new GetSearchImageListModel();
    vo.pcodeList = PlessViewUtilsSub.nullToBlank(outputVO.pcodeList);
    // 商品案内用商品名
    vo.guideGoodsName = PlessViewUtilsSub.nullToBlank(outputVO.guideGoodsName);
    // 商品案内用規格名
    vo.guideStandardName = PlessViewUtilsSub.nullToBlank(outputVO.guideStandardName);
    vo.imageName = PlessViewUtilsSub.nullToBlank(outputVO.imageName);
    vo.imageFileName = PlessViewUtilsSub.nullToBlank(outputVO.imageFileName);
    vo.imageBelongId = PlessViewUtilsSub.nullToBlank(outputVO.imageBelongID);
    vo.imageKind = PlessViewUtilsSub.nullToBlank(outputVO.imageKind);
    vo.imageType = PlessViewUtilsSub.nullToBlank(outputVO.imageType);
    vo.processInstruct = PlessViewUtilsSub.nullToBlank(outputVO.processInstruct);
    vo.remarksList = PlessViewUtilsSub.nullToBlank(outputVO.remarks);
    if (PlessViewUtilsSub.nullToBlank(outputVO.cookingExPublish) === '1') {
      vo.cookingExPublish = '1';
    } else {
      vo.cookingExPublish = '';
    }
    vo.cookingDiv = PlessViewUtilsSub.nullToBlank(outputVO.cookingDiv);
    vo.cookingNameList = PlessViewUtilsSub.nullToBlank(outputVO.cookingName);
    vo.materialNameList = PlessViewUtilsSub.nullToBlank(outputVO.materialName);
    vo.keyWordList = PlessViewUtilsSub.nullToBlank(outputVO.keyWord);
    vo.eventId = PlessViewUtilsSub.nullToBlank(outputVO.eventID);
    vo.photoContentsDiv = PlessViewUtilsSub.nullToBlank(outputVO.photoContentsDiv);
    vo.photoStudioId = PlessViewUtilsSub.nullToBlank(outputVO.photoStudioID);
    vo.imageInstructUserId = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructUser);
    vo.imageInstructDateFrom = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructDateStart);
    vo.imageInstructDateTo = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructDateEnd);
    vo.fileRegistDateFrom = PlessViewUtilsSub.nullToBlank(outputVO.fileRegistDateStart);
    vo.fileRegistDateTo = PlessViewUtilsSub.nullToBlank(outputVO.fileRegistDateEnd);
    vo.status = PlessViewUtilsSub.nullToBlank(outputVO.status);
    vo.imageInstructDiv = PlessViewUtilsSub.nullToBlank(outputVO.imageInstrucrDiv);
    vo.imageEnabledDiv = PlessViewUtilsSub.nullToBlank(outputVO.imageEnableDiv);
    vo.thisOrderCode = this.selectedOrderCode;
    vo.photoScheduleFrom = PlessViewUtilsSub.nullToBlank(outputVO.photoScheduleStart);
    vo.photoScheduleTo = PlessViewUtilsSub.nullToBlank(outputVO.photoScheduleEnd);
    vo.classCode = PlessViewUtilsSub.nullToBlank(outputVO.classCode);
    vo.multipleCode = outputVO.multipleCode;
    vo.startOrderCode = PlessViewUtilsSub.nullToBlank(outputVO.startOrderCode);
    vo.startDelivCatalogId = PlessViewUtilsSub.nullToBlank(outputVO.startDelivCatalogId);
    vo.billingName = PlessViewUtilsSub.nullToBlank(outputVO.billingName);
    vo.buyerCode = PlessViewUtilsSub.nullToBlank(outputVO.buyerCode);
    vo.outputFlg = PlessViewUtilsSub.nullToBlank(outputVO.outputFlg);
    vo.carriedForward = outputVO.carriedForward;
    vo.c2pfTarget = outputVO.c2pfTarget;
    vo.photographingChangeSchedule = outputVO.photographingChangeSchedule;
    return vo;
  }

  /**
   * UpdateImageInfoVOを返却する
   *
   * @returns {UpdateImageInfoModel}
   * @memberof KYMW1407Model
   */
  public getUpdateImageInfoVO(): UpdateImageInfoModel {
    const vo: UpdateImageInfoModel = new UpdateImageInfoModel();
    vo.imageId = this.selectedImageData.ImageId;
    vo.startOrderCode = this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode;
    if (this.imageInfoDetailBox.cmb_EndOrderCode2.nativeElement.selectedIndex === 1) {
      vo.endOrderCode = '9999999';
    } else {
      vo.endOrderCode = this.imageInfoDetailBox.txi_EndOrderCode1.selectedOrderCode;
    }
    vo.processInstruct = this.imageInfoDetailBox.cmb_ProcessInstruct.selectedCodeValue;
    vo.remarks = this.imageInfoDetailBox.remarks;
    vo.cookingExPublish = PlessViewUtilsSub.booleanTOString(this.imageInfoDetailBox.cookingExPublish);
    vo.priority = this.imageInfoDetailBox.priority;
    vo.cookingDiv = this.imageInfoDetailBox.cmb_CookingDiv.selectedCodeValue;
    vo.cookingName = this.imageInfoDetailBox.cookingName;
    vo.materialName = this.imageInfoDetailBox.materialName;
    vo.keyWord = this.imageInfoDetailBox.keyWord;
    vo.eventId = this.imageInfoDetailBox.cmb_EventId.selectedCodeValue;
    vo.photoContentsDiv = this.imageInfoDetailBox.cmb_PhotoContentsDiv.selectedCodeValue;
    vo.photoInstructContents = this.imageInfoDetailBox.photoInstructContents;
    vo.photoSchedule = PlessViewUtilsSub.editDate(this.imageInfoDetailBox.photoSchedule, '1');
    vo.photoStudioId = this.imageInfoDetailBox.cmb_PhotoStudioId.selectedStudioId;
    vo.textCaption = this.imageInfoDetailBox.caption;

    return vo;
  }

  /**
   * UpdateEnabledDeleteVOを返却する
   *
   * @returns {UpdateImageInfoEnabledModel}
   * @memberof KYMW1407Model
   */
  public getUpdateImageInfoEnabledVO(): UpdateImageInfoEnabledModel {
    const vo: UpdateImageInfoEnabledModel = new UpdateImageInfoEnabledModel();
    vo.imageId = this.selectedImageData.ImageId;
    return vo;
  }

  /**
   * KYMW0B00InputVOを返却する
   *
   * @returns {KYMW0B00InputModel}
   * @memberof KYMW1407Model
   */
  public getKYMW0B00InputVO(): KYMW0B00InputModel {
    const vo: KYMW0B00InputModel = new KYMW0B00InputModel();
    vo.processDiv = '3';
    return vo;
  }

  /**
   * KYMW0C00InputVOを返却する
   *
   * @returns {KYMW0C00InputModel}
   * @memberof KYMW1407Model
   */
  public getKYMW0C00InputVO(): KYMW0C00InputModel {
    const vo: KYMW0C00InputModel = new KYMW0C00InputModel();
    return vo;
  }

  /**
   * KYMW0E00InputVOを返却する
   *
   * @param {number} processDiv
   * @returns {KYMW0E00InputModel}
   * @memberof KYMW1407Model
   */
  public getKYMW0E00InputVO(processDiv: number): KYMW0E00InputModel {
    const vo: KYMW0E00InputModel = new KYMW0E00InputModel();
    vo.formID = 'KYMW1407';
    vo.processDiv = processDiv;
    vo.imageID = this.selectedImageData.ImageId;
    vo.imageName = this.selectedImageData.ImageName;
    vo.imageFileName = this.selectedImageData.ImageFileName;
    vo.startOrderCodeBefore = this.startOrderCodeBefore;
    vo.endOrderCodeBefore = this.endOrderCodeBefore;
    vo.startOrderCodeAfter = this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode;
    vo.endOrderCodeAfter = this.imageInfoDetailBox.txi_EndOrderCode1.selectedOrderCode;

    return vo;
  }

  /*-----------------------------------------------------------------------------------------------
  Util
  -----------------------------------------------------------------------------------------------*/
  /**
   * 【使用画像】選択されたイメージIndexを取得する
   *
   * @returns {number}
   * @memberof KYMW1407Model
   */
  public getUseImageListSelectedImageIndex(): number {
    return this.getSelectedImageIndex(this.useImageList);
  }

  /**
   * 【検索結果：商品画像】選択されたイメージIndexを取得する
   *
   * @returns {number}
   * @memberof KYMW1407Model
   */
  public getGoodsImageListSelectedImageIndex(): number {
    return this.getSelectedImageIndex(this.goodsImageList);
  }

  /**
   * 【検索結果：使用履歴】選択されたイメージIndexを取得する
   *
   * @returns {number}
   * @memberof KYMW1407Model
   */
  public getUseHistoryImageListSelectedImageIndex(): number {
    return this.getSelectedImageIndex(this.useHistoryImageList);
  }

  /**
   * 【検索結果：検索画像】選択されたイメージIndexを取得する
   *
   * @returns {number}
   * @memberof KYMW1407Model
   */
  public getSearchImageListSelectedImageIndex(): number {
    return this.getSelectedImageIndex(this.searchImageList);
  }

  /**
   * 選択されたイメージIndexを返却する
   *
   * @private
   * @param {Array<any>} imageList
   * @returns {number}
   * @memberof KYMW1407Model
   */
  private getSelectedImageIndex(imageList: Array<any>): number {
    if (this.selectedImageData != null) {
      for (let i = Number(0); i < imageList.length; i++) {
        if (imageList[i].ImageId === this.selectedImageData.ImageId) {
          return i;
        }
      }
    }
    return -1;
  }

  /**
   * 選択された使用画像をリストから削除する
   *
   * @memberof KYMW1407Model
   */
  public deleteSelectedUseImage(): void {
    this.useImageList.splice(this.getSelectedImageIndex(this.useImageList), 1);
  }

  /**
   * 選択された使用画像を前へ移動する
   *
   * @memberof KYMW1407Model
   */
  public moveFrontSelectedUseImage(): void {
    const selectedImageIndex: number = this.getSelectedImageIndex(this.useImageList);
    this.useImageList.splice(selectedImageIndex - 1, 0, this.useImageList[selectedImageIndex]);
    this.useImageList.splice(selectedImageIndex + 1, 1);
  }

  /**
   * 選択された使用画像を後ろへ移動する
   *
   * @memberof KYMW1407Model
   */
  public moveNextSelectedUseImage(): void {
    const selectedImageIndex: number = this.getSelectedImageIndex(this.useImageList);
    this.useImageList.splice(selectedImageIndex + 2, 0, this.useImageList[selectedImageIndex]);
    this.useImageList.splice(selectedImageIndex, 1);
  }

  /**
   * 選択された使用画像を先頭へ移動する
   *
   * @memberof KYMW1407Model
   */
  public moveFirstSelectedUseImage(): void {
    const selectedImageIndex: number = this.getSelectedImageIndex(this.useImageList);
    this.useImageList.splice(0, 0, this.useImageList[selectedImageIndex]);
    this.useImageList.splice(selectedImageIndex + 1, 1);
  }

  /**
   * 選択された使用画像を先頭へ移動する
   *
   * @memberof KYMW1407Model
   **/
  public moveLastSelectedUseImage(): void {
    const selectedImageIndex: number = this.getSelectedImageIndex(this.useImageList);
    this.useImageList.push(this.useImageList[selectedImageIndex]);
    this.useImageList.splice(selectedImageIndex, 1);
  }

  /**
   * 商品画像で選択した画像を使用画像に移動する
   *
   * @memberof KYMW1407Model
   */
  public moveSelectedGoodsImageToUseImage(): void {
    this.useImageList.push(this.goodsImageList[this.getSelectedImageIndex(this.goodsImageList)]);
  }

  /**
   * 使用履歴で選択した画像を使用画像に移動する
   *
   * @memberof KYMW1407Model
   */
  public moveSelectedUseHistoryImageToUseImage(): void {
    this.useImageList.push(this.useHistoryImageList[this.getSelectedImageIndex(this.useHistoryImageList)]);
  }

  /**
   * 検索画像で選択した画像を使用画像に移動する
   *
   * @memberof KYMW1407Model
   */
  public moveSelectedSearchImageToUseImage(): void {
    this.useImageList.push(this.searchImageList[this.getSelectedImageIndex(this.searchImageList)]);
  }

  /**
   * 画像詳細情報VBOX取得
   *
   * @memberof KYMW1407Model
   */
  public get imageInfoDetailBox(): KYMW1407ImageInfoDetailBoxComponent {
    return this.kymw1407Component.vw_ImageInfoDetail.imageInfoDetailBox;
  }

  /**
   * クリア処理を行う
   *
   * @memberof KYMW1407Model
   */
  public clear(): void {
    this.pcode = '';
    this.guideGoodsName = '';
    this.guideStandardName = '';
    this.useImageList = new Array<any>();
    this.goodsImageList = new Array<any>();
    this.pcodeList = new Array<any>();
    this.pcodeInfoList = new Array<any>();
    this.useHistoryImageList = new Array<any>();
    this.searchImageList = new Array<any>();
    this.goodsImagePreviewURL = '';
    this.goodsImagePreviewPath = '';
    this.goodsImageFilePath = '';
    this.imageInfoDetailBox.clear();
    this.selectedImageData = null;
    this.selectedImageExistFlg = false;
    this.tempSelectedImageData = null;
    this.imageInfoDetailChangeFlg = false;
    this.startOrderCodeBefore = '';
    this.endOrderCodeBefore = '';
    this.imageInfoDetailChangeFlg = false;
    this.kymw1407Component.vw_SearchResult.pCode = '';
    this.startOrderCodeOrigin = '';
    this.endOrderCode1Origin = '';
  }

  /**
   * 画面活性化・非活性化処理を行う
   *
   * @memberof KYMW1407Model
   */
  public procViewEnable(): void {
    // 選択コマ商品情報存在チェック
    const pcodeSetFlg = !PlessViewUtilsSub.isEmpty(this.pcode);
    this.kymw1407Component.vw_SearchResult.tab_SearchResult.tabs[0].isDisabled = !pcodeSetFlg;
    this.kymw1407Component.vw_SearchResult.tab_SearchResult.tabs[1].isDisabled = !pcodeSetFlg;
    if (!pcodeSetFlg) {
      this.kymw1407Component.vw_SearchResult.tab_SearchResult.selectedIndex = 2;
    }

    // 選択イメージ存在チェック
    const imageSetFlg: boolean = this.editMode && this.selectedImageData != null;
    this.kymw1407Component.vw_ImageInfoDetail.disabledResetBtn = !imageSetFlg;
    this.kymw1407Component.vw_ImageInfoDetail.disabledSettingBtn = !imageSetFlg;
    this.kymw1407Component.vw_ImageInfoDetail.disabledUseStopBtn = !imageSetFlg;
    this.imageInfoDetailBox.componentEnabled = imageSetFlg;

    if (imageSetFlg) {
      this.kymw1407Component.bindStartOrderCodeTextInputSelectedOrderCode(
        this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode);
      this.kymw1407Component.bindEndOrderCodeComboBox(this.imageInfoDetailBox.endOrderCode2);

      // 画像種別が「C:調理イメージ」の場合、「調理指示」を活性にする。
      if (PlessViewUtilsSub.nullToBlank(this.imageType) === 'C') {
        this.imageInfoDetailBox.disabledProcessInstruct = false;
      } else {
        this.imageInfoDetailBox.disabledProcessInstruct = true;
      }
    }

    this.updateContextMenuEnabled();
  }

  /**
   * 使用画像リストにImageIdが存在するかチェックを行う
   *
   * @param {string} imageId 画像ID
   * @returns {boolean} TRUE:存在する、FALSE:存在しない
   * @memberof KYMW1407Model
   */
  public isExistImageIdInUseImageList(imageId: string): boolean {
    for (let i = Number(0); i < this.useImageList.length; i++) {
      if (this.useImageList[i].ImageId === imageId) {
        return true;
      }
    }
    return false;
  }

  /**
   * コンテキストメニューの活性化・非活性化処理を行う
   *
   * @memberof KYMW1407Model
   */
  public updateContextMenuEnabled(): void {
    // コンテキストメニューの活性化・非活性化処理を行う
    // 使用画像
    if (this.kymw1407Component.useImageMenu != null) {
      let enabledFlg = Boolean(true);
      const selectedIndex = this.getSelectedImageIndex(this.useImageList);
      if (!this.editMode || selectedIndex < 0) {
        enabledFlg = false;
      }
      this.kymw1407Component.useImageMenu.itemsSource[0].disabled = !enabledFlg;
      this.kymw1407Component.useImageMenu.itemsSource[2].disabled = !enabledFlg;
      this.kymw1407Component.useImageMenu.itemsSource[3].disabled = !enabledFlg;
      this.kymw1407Component.useImageMenu.itemsSource[4].disabled = !enabledFlg;
      this.kymw1407Component.useImageMenu.itemsSource[5].disabled = !enabledFlg;
      this.kymw1407Component.useImageMenu.itemsSource[7].disabled = !enabledFlg;

      // 前へ・先頭へ
      if (selectedIndex === 0) {
        this.kymw1407Component.useImageMenu.itemsSource[2].disabled = true;
        this.kymw1407Component.useImageMenu.itemsSource[4].disabled = true;
      }
      // 後ろへ・最後へ
      if (selectedIndex === this.useImageList.length - 1) {
        this.kymw1407Component.useImageMenu.itemsSource[3].disabled = true;
        this.kymw1407Component.useImageMenu.itemsSource[5].disabled = true;
      }
      // 画像作成指示へ
      if (this.useImageList.length > 98) {
        this.kymw1407Component.useImageMenu.itemsSource[7].disabled = true;
      }
    }

    // 商品画像
    this.updateContextMenuCommonEnabled(this.goodsImageList, this.kymw1407Component.goodsImageMenu);

    // 使用履歴
    this.updateContextMenuCommonEnabled(this.useHistoryImageList, this.kymw1407Component.useHistoryMenu);

    // 検索画像
    this.updateContextMenuCommonEnabled(this.searchImageList, this.kymw1407Component.searchImageMenu);
  }

  /**
   * 共通コンテキストメニュー活性・非活性制御を行う
   *
   * @memberof KYMW1407Model
   */
  public updateContextMenuCommonEnabled(imageList: Array<any>, contextMenu: Menu): void {
    const selectedIndex = this.getSelectedImageIndex(imageList);
    if (selectedIndex < 0) {
      return;
    }

    // コンテキストメニュー活性化処理
    let useEnabledFlg = Boolean(false);
    if (this.editMode && this.useImageList.length < 99) {
      useEnabledFlg = true;
    }

    contextMenu.itemsSource[0].disabled = !useEnabledFlg;
    contextMenu.itemsSource[1].disabled = !this.selectedImageExistFlg;
  }

  /**
   * 親画面に通知する
   *
   * @memberof KYMW1407Model
   */
  public refreshKYMW1400(): void {
    this.kymw1407Component.refreshKYMW1400();
  }

  /**
   * 'コード：名称'の文字列を取得する
   *
   * @memberof KYMW1407Model
   */
  private getCodeValueName(code: string, name: string): string {
    let codeValueName = String('');
    if (!PlessViewUtilsSub.isEmpty(code) && !PlessViewUtilsSub.isEmpty(name)) {
      codeValueName = code + ':' + name;
    } else {
      codeValueName = code + name;
    }

    return codeValueName;
  }
}
